<template>
  <div class="set-accuracy d-flex justify-content-end" dir="rtl">
    <small class="mt-1">
      {{ hebrew ? "דיוק גבוה" : "High Accuracy" }}
    </small>
    <div class="mx-3 slider-wrap d-inline-block">
      <vue-slider
        v-model="value"
        :dragOnClick="false"
        :clickable="true"
        :min="7"
        :max="20"
        :tooltip="'active'"
        :height="9"
        :dotSize="20"
      >
      </vue-slider>
    </div>
    <small class="mt-1">
      {{ hebrew ? "נמוך" : "Low" }}
    </small>
  </div>
</template>

<script>
import { Actions } from "@/store/stateChanges"
import VueSlider from "vue-slider-component"
import "vue-slider-component/theme/default.css"

export default {
  name: "SetAccuracy",
  components: { VueSlider },
  data() {
    return {
      //value: [this.$store.state.minRange, this.$store.state.maxRange > 50 ? 50 : this.$store.state.maxRange],
      //value: this.$store.state.minRange
    }
  },
  computed: {
    hebrew() {
      return this.$settings.hebrew
    },
    value: {
      get() {
        return this.$store.state.minRange
      },
      set(value) {
        this.$store.commit("SET_MIN_RANGE", value)
        this.$store.dispatch(Actions.RUN_FOOTNOTES)
      },
    },
  },
  methods: {
    setValue(value) {
      this.$store.commit("SET_MIN_RANGE", value)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.set-accuracy {
  small {
    font-size: 12px;
    color: #646464;
    line-height: 20px;
  }
  .vue-slider-rail {
    background: white;
    border: 1px solid #d8d8d8;
    border-radius: 2px;
  }
  .vue-slider-process {
    // background-color: var(--primary);
    background-color: white;
  }
  .vue-slider-dot-handle {
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.25);
  }
  .slider-wrap {
    width: 170px;
  }
}
</style>
